/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import styled from '@themes/theme'
import useRootStore from '@store/useRootStore'
import { GlobalStoreKey } from '@v2/constants/common'
import _ from 'lodash'

interface Props {
  showSMark: boolean
  isSpecialMember?: boolean
  userTitleId?: number
  userTitleEnabled?: boolean
  className?: string
  tiny?: boolean
  small?: boolean
  medium?: boolean
  darkBorder?: boolean
  lightBorder?: boolean
  sub2Border?: boolean
  whiteBgBorder?: boolean
}
const SMark: React.FC<Props> = observer((props) => {
  const {
    showSMark,
    isSpecialMember,
    userTitleId,
    userTitleEnabled,
    className,
    tiny,
    small,
    darkBorder,
    lightBorder,
    sub2Border,
    whiteBgBorder,
    medium,
  } = props
  const { globalStore, userStore } = useRootStore()

  if (!userTitleEnabled) {
    return null
  }
  const markClassName = classNames('mark', className, {
    'medium': medium,
    'small': small,
    'tiny': tiny,
    'border dark': darkBorder,
    'border light': lightBorder,
    'border sub2': sub2Border,
    'border white-bg': whiteBgBorder,
  })

  const baseImageUrl = globalStore.findGlobalSetting(GlobalStoreKey.INGAME_IMAGES_URL).value + 'icon/user_title/'
  let imageUrl: string

  if (userTitleEnabled) {
    if (showSMark) {
      imageUrl = `${baseImageUrl}s_mark.jpg`
    } else if (!isSpecialMember && !_.isNil(userTitleId)) {
      const titleDef = userStore.userTitleDefMap[userTitleId]
      if (titleDef) {
        imageUrl = `${baseImageUrl}${titleDef.titleMarkFileName}`
      }
    }
  }

  let titleImg = <Fragment/>
  if (imageUrl) {
    titleImg = <img src={imageUrl} alt="마크" className="s-mark-img" loading="lazy"/>
  }

  return (
    <div className={markClassName}>
      {titleImg}
    </div>
  )
})

export const UserPickSpecialMemberMark = styled(SMark)`
  position: absolute;
  bottom: -4px;
  left: -4px;
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  .s-mark-img {
    width: auto;
    height: 100%;
    border-radius: 50%;
  }
  &.medium {
    bottom: 2px;
    left: -5px;
    width: 22px;
    height: 22px;
  }
  &.small {
    bottom: 4px;
    left: -2px;
    width: 18px;
    height: 18px;
  }
  &.tiny {
    bottom: -3px;
    left: -4px;
    width: 15px;
    height: 15px;
  }
  &.border {
    .s-mark-img {
      border: 3px solid;
    }
    &.medium {
      .s-mark-img {
        border-width: 2px;
      }
    }
    &.small {
      .s-mark-img {
        border-width: 2px;
      }
    }
    &.tiny {
      .s-mark-img {
        border-width: 1px;
      }
    }
    &.dark {
      .s-mark-img {
        border-color: ${props => props.theme.color.mainColor};
      }
    }
    &.light {
      .s-mark-img {
        border-color: ${props => props.theme.color.modalBg};
      }
    }
    &.sub2 {
      .s-mark-img {
        border-color: ${props => props.theme.color.subColor2};
      }
    }
    &.white-bg {
      .s-mark-img {
        border-color: ${props => props.theme.color.whiteBg};
      }
    }
  }
`
